import { SET_LOADING } from "../constants/spinner";

// eslint-disable-next-line import/prefer-default-export
export function setLoading(loading) {
  return {
    type: SET_LOADING,
    loading
  };
}
